<template>
  <div id="app">
    <template v-if="!isMobile">
      <DesktopBaseLayout>
        <router-view/>
      </DesktopBaseLayout>
    </template>
    <template v-else>
      <MobileBaseLayout>
        <router-view name="mobile"/>
      </MobileBaseLayout>
    </template>
    <Scheduler/>
  </div>
</template>

<script>
import Scheduler from './components/scheduler/Scheduler.vue';
import DesktopBaseLayout from './components/DesktopBaseLayout.vue';
import MobileBaseLayout from './components/MobileBaseLayout.vue';

export default {
  name: 'App',
  components: {
    DesktopBaseLayout,
    MobileBaseLayout,
    Scheduler,
  },
  data() {
    return {
      isMobile: false,
    };
  },
  computed: {
    isDeviceMobile() {
      return this.$store.state.isMobile;
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize, { passive: true });
    navigator.serviceWorker.getRegistrations().then(
      (registrations) => {
        registrations.forEach((reg) => reg.unregister());
      },
    );
  },
  methods: {
    onResize() {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
        .test(navigator.userAgent);
      this.$store.commit('SET_MOBILE', isMobile);
    },
  },
  watch: {
    isDeviceMobile(mobile) {
      this.isMobile = mobile;
    },
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true });
    }
  },
};
</script>

<style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  #app {
    background-color: #000000;
  }
</style>
